module.exports = __webpack_public_path__ + "img/luntanA_09.1b0cde6e.jpg";